import { createFileRoute } from "@tanstack/react-router";
import SupplementalResearchPage from "@/pages/SupplementalResearchPage";
export const Route = createFileRoute("/supplemental-research")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Clinical Research | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Explore peer-reviewed clinical research and academic studies supporting TMS Therapy, SAINT® protocol, IV Ketamine, and SPRAVATO® esketamine.",
        },
        {
          property: "og:title",
          content: "Clinical Research | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Explore peer-reviewed clinical research and academic studies supporting TMS Therapy, SAINT® protocol, IV Ketamine, and SPRAVATO® esketamine.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/supplemental-research",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/supplemental-research",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SupplementalResearchPage />;
}
